import { createApp } from 'vue';
import { createPinia } from 'pinia'

import mitt from 'mitt'; // Import mitt
const emitter = mitt(); // Initialize mitt
export default emitter; // Export mitt

const pinia = createPinia();
const app = createApp();

/**
 * Components
 */
const componentFiles = require.context('@components/', true, /\.(vue|js)$/i);
componentFiles.keys().map(key => {
  let componentName = key
    .split('.')[1]
    .replace(/\//g, '')
    .replace(/([A-Z])/g, '-$1')
    .replace(/^-/, 'v-')
    .toLowerCase();

  if (componentName.match(/index$/)) {
    componentName = componentName.replace('index', '');
  }

  app.component(componentName, componentFiles(key).default);
});

app.use(pinia);
app.provide('emitter', emitter).mount('#app');
